import { useRouter } from "next/router";

export default function useMintType() {
  const router = useRouter();

  return router.pathname === "/mint/validator" ||
    router.pathname === "/mint/recover/validator"
    ? "validator"
    : "claimer";
}
